import { cn } from "@/utils/cn";
import { useNavigate } from "react-router-dom";

export default function ProfileOverview({
  name,
  accountType,
  image,
  className = "",
}) {
  const navigate = useNavigate();

  return (
    <div className={cn("flex flex-col items-center text-center", className)}>
      {/* Profile Image */}
      <div className="w-36 h-36 mb-4">
        <img
          className="w-full h-full rounded-full object-cover border border-gray-100"
          src={image}
          alt={name}
        />
      </div>

      {/* Name and Account Type */}
      <h1 className="text-xl font-semibold text-gray-800 mb-1">{name}</h1>
      <p className="text-orange-500 text-sm mb-6">{accountType}</p>

      {/* Edit Profile Button */}
      <button
        onClick={() => navigate("/profile/edit/general")}
        className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-md flex items-center gap-3 transition-colors duration-200 text-base font-medium"
      >
        Edit Profile
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
        </svg>
      </button>
    </div>
  );
}